import { match } from "@stepapp/core";
import { Block, Button, SvgIcon, Typography, palette, spacing } from "@stepapp/ui";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import Animated, { FadeIn } from "react-native-reanimated";

type EditAttributesProps = {
  questionType: string;
  handleClose: () => void;
};

const EditReservationSuccess = ({ questionType, handleClose }: EditAttributesProps) => {
  const { t } = useTranslation();

  const headerTitle = useMemo(
    () =>
      match(questionType)
        .with("date", () => t("screens.serviceDetails.submitChangeConfirmation"))
        .with("cancelReservation", () => t("screens.cancelReservation.reservationCanceled"))
        .with("cancelSubscription", () => t("screens.cancelReservation.subscriptionCanceled"))
        .otherwise(() => t("screens.serviceDetails.submitDetailsConfirmation")),
    [questionType, t],
  );

  return (
    <Animated.View entering={FadeIn} style={styles.container}>
      <Block alignCenter justifyEnd flex={1}>
        <Block alignCenter justifyCenter marginVertical={3} style={styles.successIcon}>
          <SvgIcon color={palette.common.white} name="done" size={50} />
        </Block>
        <Typography center variant="newH2">
          {headerTitle}
        </Typography>
      </Block>

      <Button
        label={t("screens.serviceDetails.close")}
        onPress={handleClose}
        type="secondary"
        style={styles.successButton}
      />
    </Animated.View>
  );
};

export default EditReservationSuccess;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: spacing.unit * 2,
  },
  successButton: {
    flex: 1,
    width: "100%",
    justifyContent: "flex-end",
    paddingBottom: spacing.unit * 2,
  },
  successIcon: {
    backgroundColor: palette.primary.main,
    borderRadius: spacing.unit * 4,
    height: spacing.unit * 6.635,
    width: spacing.unit * 6.75,
  },
});
